export default {
  cards: [
    {label: 'Kobie', image: require('../img/kobie.jpg'), imageLarge: require('../img/kobie-lg.jpg')},
    {label: 'Kerry', image: require('../img/kerry.jpg'), imageLarge: require('../img/kerry-lg.jpg')},
    {label: 'Yves', image: require('../img/yves.jpg'), imageLarge: require('../img/yves-lg.jpg')},
    {label: 'Kara', image: require('../img/kara.jpg'), imageLarge: require('../img/kara-lg.jpg')}
  ]
}